import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  templateUrl: "./banner.component.html",
  styles: [
    `
      :host {
        position: relative;
        display: block;
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
      }
    `,
  ],
})
export class BannerComponent implements OnInit {
  item: string;
  // extension: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<BannerComponent>
  ) {}

  ngOnInit() {
    // console.log(this.data.fileUrls)
    // var extn = this.data.fileUrls.name.split(".").pop();
    // this.extension = extn;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
